import { getSinglePhotographerPublicPackages } from '../../apiCalls/PackageRequests'
import PortfolioHelmet from '../../seo/portfolio'
import { Event } from '../trackers/Tracking'
import TagFilterBar from './TagFilterBar'
import { getPublicPhotographer } from 'apiCalls/PhotographerRequests'
import { SpinLoaderFullScreen } from 'components/Loader/SpinLoaderFullScreen'
import PortfolioHeader from 'components/public/PortfolioHeader'
import MarketplaceCarousel from 'components/public/marketplace/MarketplaceCarousel'
import { useAppContext } from 'context/AppContext'
import React, { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'
import WebFont from 'webfontloader'
// import { Helmet } from 'react-helmet'

function PublicPortfolio(props) {
  const { identifier } = props.match.params
  const [activeTag, setActiveTag] = useState(null)
  const [photographerTags, setPhotographerTags] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [filteredTags, setFilteredTags] = useState(null)
  const [publicPackages, setPublicPackages] = useState(null)
  const [activePortfolioJSX, setActivePortfolioJSX] = useState(null)
  const [BioStringFinal, setBioStringFinal] = useState(null)
  const [photographer, setPhotographer] = useState(null)
  const [context, dispatch] = useAppContext()
  const [font, setFont] = useState(null)
  const [secondaryFont, setSecondaryFont] = useState(null)
  const [background, setBackground] = useState(false)

  // INITIAL LOAD OF PHOTOGRAPHER AND PORTFOLIO
  useEffect(() => {
    getPublicPhotographer(identifier).then((response) => {
      if (response && response.status === 200) {
        Event('View', 'Portfolio Viewed', `URL Path of Portfolio - ${window.location.href}`)
        setPhotographer(response.data)
        setPhotographerTags(response.data.tags)
        setActiveTag(response.data.tags[0])

        const displayFont = response.data.displayFont

        setFont(response.data.displayFont)
        setSecondaryFont(response.data.secondaryFont)

        const basicFonts = [
          'Tahoma',
          'Georgia',
          'Arial',
          'Helvetica',
          'Trebuchet MS',
          'Verdana',
          'Times New Roman',
          'Times',
          'Courier New',
          'Segoe UI',
        ]

        if (!basicFonts.includes(displayFont) && !!displayFont) {
          WebFont.load({
            google: {
              families: !!response.data.secondaryFont
                ? [displayFont, response.data.secondaryFont]
                : [displayFont],
            },
          })
        }

        setBackground(response.data.backgroundColor)
      } else {
        dispatch({
          type: 'setAlertType',
          alertType: 'error',
        })
        dispatch({
          type: 'setAlertText',
          alertText: ['Something went wrong, could not find photographer '],
        })
        setTimeout(() => {
          window.location.href = `/`
        }, 1000)
        throw new Error(response.data)
      }
    })

    getSinglePhotographerPublicPackages(identifier).then((response) => {
      if (response.status === 200) {
        let packages = response.data.filter((pack) => pack.status === 1)
        setPublicPackages(packages)
      } else {
        setTimeout(() => {
          window.location.href = `/`
        }, 1000)
        throw new Error(response.data)
      }
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (publicPackages && photographerTags) filterEmptyTags(publicPackages, photographerTags)
  }, [publicPackages, photographerTags])

  const filterEmptyTags = (packages, tags) => {
    let existingTags = []
    packages.forEach((pack) => {
      pack.priorityTags.forEach((pTag) => {
        if (!existingTags.includes(pTag.tag)) existingTags.push(pTag.tag)
      })
    })
    let filteredTags = tags
    filteredTags = filteredTags.filter((tag) => existingTags.includes(tag.name))
    setFilteredTags(filteredTags)
  }

  useEffect(() => {
    let orderedByPriority = []
    if (publicPackages) {
      orderedByPriority = publicPackages
        .filter((pack) =>
          pack.priorityTags.some((priorityTag) => {
            if (priorityTag.tag === activeTag.name) return true
            return false
          }),
        )
        .sort((a, b) => {
          return parseInt(a.priorityTags.find((tag) => tag.tag === activeTag.name).priority) >
            parseInt(b.priorityTags.find((tag) => tag.tag === activeTag.name).priority)
            ? 1
            : -1
        })
    }

    if (orderedByPriority && photographer && activeTag) {
      const activePortJSX = (
        <Grid key={uuidv4()} Category={activeTag.name}>
          <PortfolioHelmet
            activeTag={activeTag.name}
            photographer={photographer}
            location={props.history.location}
          />
          {orderedByPriority.map((pack, index) => (
            <GridCell key={uuidv4()} index={index}>
              <CustomCarouselWrap>
                <MarketplaceCarousel
                  items={[pack]}
                  history={props.history}
                  fontColor={photographer.fontColor}
                  font={font}
                  secondaryFont={secondaryFont}
                />
              </CustomCarouselWrap>
            </GridCell>
          ))}
        </Grid>
      )

      activePortJSX && setActivePortfolioJSX(activePortJSX)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicPackages, activeTag, photographer])

  useEffect(() => {
    if (activeTag) {
      if (activeTag.bio) {
        let string1 = activeTag.bio.replace(/(<\/h1>|<\/h2>|<\/h3>|<\/h4>|<\/h5>|<\/h6>)/g, '</p>')
        let string2 = string1.replace(/(<h1>|<h2>|<h3>|<h4>|<h5>|<h6>)/g, '<p>')
        setBioStringFinal(string2)
      }

      // MAKE SURE CUSTOM FAVICON IS UPLOADED
      if (photographer.faviconImage) {
        const favicon = document.getElementById('favicon')
        favicon.href = photographer.faviconImage
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTag])

  useEffect(() => {
    if (activeTag) {
      if (loaded) props.history.push(`/portfolio/${identifier}/${activeTag.name.replaceAll(' ', '-')}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTag])

  useEffect(() => {
    if (activeTag && photographerTags && props.history && loaded) {
      let url = props.history.location.pathname

      const urlSegments = url.split('/')

      if (urlSegments.length === 4) {
        let urlTag = urlSegments.pop()
        let found = filteredTags.filter(
          (tag) => tag.name === urlTag || tag.name === urlTag.replaceAll('-', ' '),
        )[0]
        if (found) setActiveTag(found)
        else {
          props.history.push(`/portfolio/${identifier}/${activeTag.name.replaceAll(' ', '-')}`)
        }
      } else {
        props.history.push(`/portfolio/${identifier}/${activeTag.name.replaceAll(' ', '-')}`)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, props.history.location])

  // CHECKING TO SEE EVERYTHING IS LOADED

  if (!loaded) {
    // CHECKING TO SEE EVERYTHING IS LOADED
    const loadingComplete = !!(publicPackages && photographer && photographerTags && filteredTags)
    // CASE FOR LOADING PORTFOLIO WHEN PHOTOGRAPHER HAS NO PACKAGES
    const noPackages = !context.packages.length && Object.keys(context.photographer).length

    if (!!(loadingComplete || noPackages)) {
      setLoaded(true)
    }
  }

  return loaded ? (
    <Wrapper background={background} font={font} fontColor={photographer.fontColor}>
      {/* <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet> */}
      <PortfolioHeader
        coverPhoto={
          photographer.coverImage?.length
            ? context.isMobile
              ? photographer.coverImage[0].thumbnail
              : photographer.coverImage[0].image
            : photographer.companyImage
        }
        photographer={photographer}
        font={font}
        secondaryFont={secondaryFont}
      />
      <SubContainer>
        <TagFilterBarWrapper>
          <TagFilterBar
            packs={publicPackages}
            identifier={identifier}
            active={activeTag}
            parentId={'AdminPortfolio'}
            setActiveTag={setActiveTag}
            canBeNull={false}
            tags={filteredTags}
            setTags={setPhotographerTags}
            location={'Public-Portfolio'}
            history={props.history}
            fontColor={photographer.fontColor}
            font={font}
          />
        </TagFilterBarWrapper>
        {BioStringFinal && <BioWrap>{ReactHtmlParser(BioStringFinal)}</BioWrap>}
        {activePortfolioJSX}
      </SubContainer>
      {photographer && photographer.activeSubscription === undefined ? (
        <FooterImg alt="public footer image" src={photographer.companyImage} />
      ) : null}
    </Wrapper>
  ) : (
    <div>
      {' '}
      <SpinLoaderFullScreen />
    </div>
  )
}

export default PublicPortfolio

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  background: ${(props) => props.background && props.background};
  font-family: ${(props) => props.font && props.font};
  color: ${(props) => (props.fontColor ? props.fontColor : 'var(--black)')};
`
const SubContainer = styled.div`
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1em 0 2em 0;
  @media (max-width: 1200px) {
    font-size: 11px;
    width: 94vw;
  }
  @media (max-width: 900px) {
    font-size: 16px;
    width: 45em;
  }
  @media (max-width: 800px) {
    font-size: 15px;
  }
  @media (max-width: 750px) {
    font-size: 14px;
  }
  @media (max-width: 700px) {
    font-size: 13px;
  }
  @media (max-width: 650px) {
    font-size: 12px;
  }
  @media (max-width: 600px) {
    font-size: 11px;
  }
  @media (max-width: 550px) {
    font-size: 10px;
  }
  @media (max-width: 500px) {
    font-size: 9px;
    width: 47em;
  }
  @media (max-width: 450px) {
    font-size: 8px;
  }
  @media (max-width: 400px) {
    font-size: 7px;
  }
  @media (max-width: 350px) {
    font-size: 6px;
  }
`

const Header = styled.div`
  position: relative;
  font-size: 11px;
  margin: 2em 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1em;
  @media (max-width: 1000px) {
    flex-direction: column;
    height: auto;
  }
  @media (max-width: 600px) {
    font-size: 11px;
  }
  @media (max-width: 550px) {
    font-size: 10px;
  }
  @media (max-width: 500px) {
    font-size: 9px;
  }
  @media (max-width: 450px) {
    font-size: 8px;
  }
  @media (max-width: 400px) {
    font-size: 7px;
  }
  @media (max-width: 350px) {
    font-size: 6px;
  }
`

const TagFilterBarWrapper = styled.div`
  width: 100%;
  font-weight: 600;
  height: auto;
  font-size: 11px;
  @media (max-width: 1000px) {
    font-size: 10px;
  }
  @media (max-width: 600px) {
    font-size: 9px;
  }
  @media (max-width: 500px) {
    font-size: 8px;
  }
  @media (max-width: 400px) {
    font-size: 7px;
  }
`

const Grid = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  display: grid;
  grid-row-gap: 5vw;
  grid-column-gap: 3vw;
  grid-template-columns: repeat(3, minmax(20vw, 1fr));
  margin: 3em 0 0 0;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(30vw, 1fr));
    grid-column-gap: 4vw;
  }
  @media (max-width: 900px) {
    grid-template-columns: repeat(1, minmax(70vw, 1fr));
    width: auto;
  }
`

const GridCell = styled.div`
  position: relative;
  width: 100%;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.index % 3 === 1 ? 'center' : props.index % 3 === 2 ? 'flex-end' : 'flex-start'};
  @media (max-width: 1200px) {
    align-items: ${(props) => (props.index % 2 === 1 ? 'flex-end' : 'flex-start')};
  }
  @media (max-width: 900px) {
    width: auto;
  }
`

const CustomCarouselWrap = styled.div`
  font-size: 11.5px;
  @media (max-width: 1900px) {
    font-size: 10.5px;
  }
  @media (max-width: 1700px) {
    font-size: 9.5px;
  }
  @media (max-width: 1500px) {
    font-size: 8.5px;
  }
  @media (max-width: 1350px) {
    font-size: 7.5px;
  }
  @media (max-width: 1200px) {
    font-size: 11px;
  }
  @media (max-width: 1100px) {
    font-size: 10px;
  }
  @media (max-width: 1000px) {
    font-size: 9px;
  }
  @media (max-width: 900px) {
    font-size: 16px;
  }
  @media (max-width: 800px) {
    font-size: 15px;
  }
  @media (max-width: 750px) {
    font-size: 14px;
  }
  @media (max-width: 700px) {
    font-size: 13px;
  }
  @media (max-width: 650px) {
    font-size: 12px;
  }
  @media (max-width: 600px) {
    font-size: 11px;
  }
  @media (max-width: 550px) {
    font-size: 10px;
  }
  @media (max-width: 500px) {
    font-size: 9px;
  }
  @media (max-width: 450px) {
    font-size: 8px;
  }
  @media (max-width: 400px) {
    font-size: 7px;
  }
  @media (max-width: 350px) {
    font-size: 6px;
  }
`

const BioWrap = styled.div`
  width: 100%;
  font-size: 16px;
  margin: 16px 0 0 0;
  line-height: 1.5;
`
const FooterImg = styled.img`
  margin: 50px 0 25px 0;
  width: 80px;
  border-radius: 10px;
`

Header.displayName = 'PublicPortfolioHeader'
Wrapper.displayName = 'PublicPortfolioContainer'
